import PropTypes from 'prop-types';

import RichText from '../../../Core/RichText';
import AppStores from '../../AppStores';

import {
  Grid,
  Content,
  Img,
  Header,
  CtasWrapper,
  StyledCtas,
  StyledSection,
} from './styles';

const DigitalBankBanner = ({ data }) => {
  if (!data) return null;

  const {
    imageDam,
    heading,
    bodyCopy,
    component,
    badges,
    ctas,
    imagePositioning,
    theme,
    backgroundColor,
  } = data;

  return (
    <StyledSection $backgroundColor={backgroundColor}>
      <Grid
        className={`${imagePositioning} ${component} ${theme} ${backgroundColor}`}
      >
        <Content>
          <Header>{heading && <RichText document={heading} />}</Header>
          {bodyCopy && <RichText document={bodyCopy} />}
          <CtasWrapper>
            {badges && <AppStores badges={badges} />}
            {ctas && <StyledCtas ctas={ctas} />}
          </CtasWrapper>
        </Content>
        <Img src={imageDam} alt={imageDam.altText || ''} objectFit="contain" />
      </Grid>
    </StyledSection>
  );
};

DigitalBankBanner.propTypes = {
  data: PropTypes.shape().isRequired,
};

export default DigitalBankBanner;
